import * as React from "react"
import { Text, Button, ButtonProps } from "@chakra-ui/react"
import { FaPinterestSquare } from "react-icons/fa"

type AdditionProps = {
  onlyIcon?: boolean
}

export const PinterestButton: React.FC<ButtonProps & AdditionProps> =
  React.memo(({ onlyIcon, ...props }) => {
    return (
      <Button
        background="#c8232c"
        color="white"
        width="130px"
        marginTop="1rem"
        _active={{}}
        _hover={{}}
        _focus={{}}
        {...props}
      >
        <FaPinterestSquare />
        {!onlyIcon && <Text marginLeft="0.5rem">Pinterest</Text>}
      </Button>
    )
  })
